var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCloseDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  fill: "#BECCD8",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fillOpacity: 0,
  width: 18,
  height: 18
}), /*#__PURE__*/React.createElement("polygon", {
  points: "13.6666667 5.40808232 12.5360805 4.33333333 9 8.06097499 5.46391953 4.33333333 4.33333333 5.40808232 7.73817162 8.99770978 4.33478144 12.5874052 5.45993973 13.6666667 9 9.93348773 12.5400603 13.6666667 13.6652186 12.5874052 10.2609671 8.99770978"
}))));

export default SvgCloseDropdown;